export const CURRENCY_META = {
  BRL: { prefix: '+55', symbol: 'R$', label: 'Brazil', decimals: 2, requiresAlipayAccount: false },
  MXN: { prefix: '+52', symbol: 'MX$', label: 'Mexico', decimals: 2, requiresAlipayAccount: false },
  JPY: { prefix: '+81', symbol: '¥', label: 'Japan', decimals: 0, requiresAlipayAccount: true },
  CC: { prefix: '+', symbol: '$', label: 'Credit Card', decimals: 2, requiresAlipayAccount: false, requiresPayerInfo: false },
};

export function getCurrencyMeta(currency) {
  return CURRENCY_META[(currency || '').toUpperCase()] || CURRENCY_META.BRL;
}

/** Convert user-entered amount to gateway smallest unit (centavos or whole yen). */
export function amountToGatewayUnits(amountText, currency) {
  const meta = getCurrencyMeta(currency);
  const value = Number(String(amountText).replace(/,/g, '').trim());
  if (!Number.isFinite(value) || value <= 0) {
    return 0;
  }
  if (meta.decimals === 0) {
    return Math.round(value);
  }
  return Math.round(value * 100);
}
